<!--<div *ngIf="claims">
  <router-outlet></router-outlet>
</div>-->
@if(claims)
{
<router-outlet></router-outlet>
}
<ng-template #SessionPopup>
  <mat-dialog-content class="f-s-14 lh-16 p-10">
      <div class="col-12">
        <div class="text-center m-t-10 m-b-10">
          <img src="../assets/images/user/session-timeout.gif" alt="Your session has been timeout, please login" loading="lazy" />
          <br />
          <mat-label class="m-b-6 m-t-14">
            Your session will expire in </mat-label>
          <mat-label class="session-timeout m-t-8 m-b-10">
            <!--{{format(minutes)}} min {{format(seconds)}} secs-->
            {{minutes}} min {{seconds}} secs
          </mat-label>
          <mat-label class="m-t-8">You will be redirected to the login page</mat-label>
        </div>
        <div class="row text-center m-t-14">
          <div class="col-lg-12 m-b-10">
            <div class="d-flex justify-content-center">
              <button mat-flat-button color="primary" class="btn-stayLogged" (click)="stayLoggedIn()">
                <div class="d-flex align-items-center">
                  <span class="hidemenutext">  Stay Logged In </span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="btn-stayLogout bg-error b-0 border-radius5 p-y-6 p-x-10" (click)="LoginWithDifferentAccount()">
                <div class="d-flex text-black">
                  <span class="f-s-14 text-white"> Logout </span>
                </div>
              </button>
            </div>
          </div>  
        </div>
      </div>
   </mat-dialog-content>
</ng-template>
